import React from 'react';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import authorized from '../../../authorized';
import { Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Layout from '../../ui/Layout';
import CompleteAccountForm from './CompleteAccountForm';

export const CompleteAccount = ({ user, error, location }) => {
  const isAuthorized = authorized({ user });
  let history = useHistory();
  if (isAuthorized) return <Redirect to={location.from || { pathname: '/' }} />;
  const handleSubmit = values => {
    history.push('/login');
  };
  return (
    <Layout route="complete-account">
      <Row className="justify-content-sm-center">
        <Col sm>
          <div className="logo">Crow's Nest™ App</div>
          <h1>Crow's Nest™ App</h1>
          {error && <Alert variant="warning">{error.message}</Alert>}
          <CompleteAccountForm onSubmit={handleSubmit} />
        </Col>
      </Row>
    </Layout>
  );
};

const mapState = state => {
  const { result: user } = state.login.toJS();
  return { user };
};

export default connect(mapState)(CompleteAccount);
